_   = require('underscore')
Vue = require('vue/dist/vue')

module.exports =
  namespaced: true

  state:
    openRequests: 0

  getters:

    hasOpenRequests: (state) ->
      state.openRequests > 0

  mutations:

    setOpenRequestCount: (state, count = 0) ->
      count = 0 if count < 0 || !_.isNumber(count) || _.isNaN(count)

      Vue.set(state, 'openRequests', count)

  actions:

    startRequest: (context) ->
      context.commit('setOpenRequestCount', context.state.openRequests + 1)

    finishRequest: (context) ->
      context.commit('setOpenRequestCount', context.state.openRequests - 1)



// WEBPACK FOOTER //
// ./assets/js/frontend/store/server/index.coffee